import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { MijnHttpErrorService } from '@ap/mijn-error-handler';

import { MijnOmgevingNavigation } from '../../mijn-omgeving.navigation';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
    public constructor(
        private readonly navigation: MijnOmgevingNavigation,
        private readonly mijnHttpErrorService: MijnHttpErrorService
    ) {}

    public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(
            catchError((response: HttpErrorResponse) => {
                if (this.mijnHttpErrorService.shouldNavigateToError(response)) {
                    this.navigation.toFout();
                }
                return throwError(response);
            })
        );
    }
}
